import App from './file_viewer/FileViewer.svelte';

const app = new App({
	target: document.getElementById("body"),
	props: {}
});

export default app;
